import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { LegalPage, LegalPageProps } from '../components/legal/LegalPage'
import { renderLegalDoc } from '../functions/legalContent'

type Props = Omit<LegalPageProps, 'docKey'>

/**
 * Política de Privacidade v4.0 (handoff "Páginas Legais"): conteúdo em
 * content/legal/, renderizado build-time. PT é o idioma autoritativo em
 * /privacidade; qualquer outro locale recebe a tradução de trabalho EN (URL
 * canônica /en/privacy-policy via rewrite no next.config.js).
 */
export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
  const lang = locale === 'pt' ? 'pt' : 'en'
  const { html, toc } = renderLegalDoc('privacy', lang)

  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'pt', ['common'])),
      lang,
      html,
      toc,
    },
  }
}

export default function Privacidade(props: Props) {
  return <LegalPage docKey="privacy" {...props} />
}
